import { ILinkedServiceTypeMetadata } from 'app/extensibility/metadatas/resource-type/linked-service-type-metadata';

import { adfModelTypeMap } from 'app/registries/consts/adf-model-type-map-const';
import { CopyJobMode } from 'app/model/copyjob/type';
import { GlobalVariables } from 'app/services/globals';
import { ConnectionAuthKind } from 'shell-models-lib';
import { DataSourceOptionKind, CommonResourceKind as ResourceKind } from '@powerquery/mashup-editor-client';

export const vivaInsightsMetadata: ILinkedServiceTypeMetadata = {
    type: adfModelTypeMap.vivaInsights.linkedServiceType,
    displayName: stringResources.VivaInsights_DisplayText,
    linkedServiceKind: 'table',
    icon: {
        className: 'svg-i-100x100-VivaInsights'
    },
    isFirstClass: true,
    category: ['ServicesApps'],
    disabled: !GlobalVariables.enableVivaInsightsConnector,
    supportedInTrident: true,
    isKnownInPipelineContext: true,
    supportDatasetV2: true,
    supportedAuthKindsInTrident: [ConnectionAuthKind.OAuth2, ConnectionAuthKind.WorkspaceIdentity],
    pqoDataSourceOption: {
        kind: DataSourceOptionKind.Extension,
        resourceKind: 'VivaInsights' as ResourceKind
    },
    controls: [],
    copySourceTypes: [adfModelTypeMap.vivaInsights.copySourceType],
    copySinkTypes: [],
    supportCopyJobSource: true,
    supportCopyJobSink: false,
    supportedJobModesAsSource: [CopyJobMode.FullCopy],
    tableNameAlias: 'reportId'
};
